import { Injectable } from '@angular/core';

import { Select, Store } from '@ngxs/store';

import * as actions from './features.actions';
import { FeaturesSelectors } from './features.selectors';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FeaturesFacade {

    @Select(FeaturesSelectors.getSemiPrivatePackagesEnabled) semiPrivatePackagesEnabled$!: Observable<boolean>;

    constructor(private state: Store) { }

    loadFeatures = () => this.state.dispatch(new actions.LoadFeaturesAction());
    getFeaturesSnapshot = () => this.state.selectSnapshot(FeaturesSelectors.getFeatures);
}
